import { formatCurrency } from "../../utils/formatters";
import QuantityControl from "../../components/cart/QuantityControl";

function CartItemRow({ item, onQuantityChange, onRemove, onUpdateNote }) {
  const unitPrice = Number(item.price || 0);
  const lineTotal = unitPrice * item.quantity;

  return (
    <article className="cart-item-row">
      <div className="cart-item-image">
        {item.image ? <img alt="" src={item.image} /> : <span>No image</span>}
      </div>

      <div className="cart-item-main">
        <div>
          <p className="cart-item-category">{item.categoryName}</p>
          <h3>{item.name}</h3>
          <p className="muted-text">{item.locationName}</p>
        </div>

        <label className="cart-note-field">
          <span>Item note</span>
          <input
            onChange={(event) => onUpdateNote(item.id, event.target.value)}
            placeholder="Optional note"
            value={item.customer_note || ""}
          />
        </label>
      </div>

      <div className="cart-item-actions">
        <strong>{formatCurrency(lineTotal)}</strong>
        <span>{formatCurrency(unitPrice)} each</span>
        <QuantityControl
          quantity={item.quantity}
          onDecrease={() => onQuantityChange(item.id, item.quantity - 1)}
          onIncrease={() => onQuantityChange(item.id, item.quantity + 1)}
        />
        <button className="btn btn-light btn-sm" onClick={() => onRemove(item.id)} type="button">
          Remove
        </button>
      </div>
    </article>
  );
}

export default CartItemRow;
